const stylesheet = new CSSStyleSheet();stylesheet.replaceSync(`input {
  background: none;
  border-radius: 2rem;
  border: 0.1rem solid var(--surface0);
  padding: 0.5rem;
  width: fit-content;
}
`);export default stylesheet;